const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const compressImageToDataUrl = (file, {
  maxInputBytes = 8 * 1024 * 1024,
  maxDimension = 1200,
  quality = 0.82,
} = {}) => new Promise((resolve, reject) => {
  if (!file) {
    resolve(null);
    return;
  }

  if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
    reject(new Error("Use uma imagem JPG, PNG ou WebP."));
    return;
  }

  if (file.size > maxInputBytes) {
    reject(new Error("A imagem deve ter no máximo 8 MB."));
    return;
  }

  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  image.onload = () => {
    try {
      const largestSide = Math.max(image.naturalWidth, image.naturalHeight);
      const scale = largestSide > maxDimension ? maxDimension / largestSide : 1;
      const width = Math.max(1, Math.round(image.naturalWidth * scale));
      const height = Math.max(1, Math.round(image.naturalHeight * scale));
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;
      if (!context) {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Não foi possível preparar a imagem."));
        return;
      }

      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, width, height);
      context.drawImage(image, 0, 0, width, height);

      canvas.toBlob((blob) => {
        URL.revokeObjectURL(objectUrl);
        if (!blob) {
          reject(new Error("Não foi possível preparar a imagem."));
          return;
        }

        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("Não foi possível ler a imagem."));
        reader.readAsDataURL(blob);
      }, "image/webp", quality);
    } catch (error) {
      URL.revokeObjectURL(objectUrl);
      reject(error);
    }
  };

  image.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    reject(new Error("Não foi possível carregar a imagem."));
  };

  image.src = objectUrl;
});
